import request from "./../utils/request";
import { UtilFunctions } from "../utils/UtilFunctions";
import _ from "lodash";
export function getSettings() {
    return request.get(`/settings/get-all`);
}

export function updateSettings(newSettings, prevSettings) {
    newSettings = _.cloneDeep(newSettings);
    prevSettings = _.cloneDeep(prevSettings);
    const diff = UtilFunctions.difference(newSettings, prevSettings);
    newSettings.diff = diff;
    console.log("updateSettings called2", { diff, newSettings, prevSettings });
    return request.put(`/settings`, newSettings);
}


export function forceUpdateSettings(siteId, updatingSettingFields) {
    return request.post(`/settings/force-update-settings`, { siteId, updatingSettingFields });
}
